import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "edit",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "dataset-edit" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
